<template>
  <v-container>
    <btn-a
      class="ma-2"
      outlined
      rounded
      color="primary"
      @click="itemDialogOpen"
    >
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
    <v-list two-line subheader v-if="value.stageItemsCons" :loading="loading">
      <div v-for="(item, i) in value.stageItemsCons" :key="i">
        <v-list-item v-if="!loading">
          <v-list-item-content>
            <v-list-item-title>{{ getDescItem(item) }}</v-list-item-title>
            <v-list-item-subtitle
              >{{ $t("entities.stageItem.props.qt") }}:
              {{ item.qt }}</v-list-item-subtitle
            >
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="itemDialogOpen(item)">
              <v-icon color="warning">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn icon @click="itemRemove(item)">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider
          v-if="
            !loading && value.stageItemsCons && value.stageItemsCons.length > 0
          "
        ></v-divider>
      </div>
    </v-list>
    <dialog-d
      ref="itemDialog"
      title="item"
      @confirm="itemConfirm"
      @cancel="itemDialogCancel"
    >
      <stageItemForm ref="form" v-model="selectedItem" />
    </dialog-d>
  </v-container>
</template>


<script>
import stageItemForm from "./stageItemForm";
export default {
  components: { stageItemForm },
  props: {
    value: {
      default: () => {
        return {
          stageItemsCons: []
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      selectedItem: {},
      selectedItemRef: null
    };
  },

  watch: {
    async value() {
      await this.getItemsByIds();
    }
  },
  methods: {
    async getItemsByIds() {
      this.loading = true;
      if (this.value.stageItemsCons.length == 0) {
        this.loading = false;
        return;
      }

      let itemIds = [];
      this.value.stageItemsCons.forEach(i => itemIds.push(i.itemId));
      let res = await this.$http.get("item/s-ids?ids=" + itemIds.toString());
      if (res.success) this.items = res.data;
      this.loading = false;
    },
    getDescItem(value) {
      let item = this.items ? this.items.filter(i => i.id == value.itemId)[0] : null;
      return item ? item.description : value.itemDescription;
    },
    itemDialogCancel() {
      this.selectedItemRef = null;
    },
    async itemConfirm() {
      if (!this.$refs.form.isValid()) return;
      if (this.selectedItemRef) {
        Object.assign(this.selectedItemRef, this.selectedItem);
      } else {
        this.value.stageItemsCons.push(this.selectedItem);
      }
      this.$refs.itemDialog.open();
      this.selectedItemRef = null;
      await this.getItemsByIds();
    },
    async itemRemove(item) {
        if(!(await this.$confirm())) return;
      let index = this.value.stageItemsCons.indexOf(item);
      if (index >= 0) this.value.stageItemsCons.splice(index, 1);
    },
    itemDialogOpen(item) {
      if (item) {
        this.selectedItemRef = item;
        let obj = {};
        Object.assign(obj, item);
        this.selectedItem = obj;
      } else {
        this.selectedItem = {};
      }

      this.$refs.itemDialog.open();
    }
  },
  async mounted() {
    await this.getItemsByIds();
  }
};
</script>